<template>
<div>
  <section>
    <v-container container--fluid grid-list-md>
      <v-row justify="center" style="position: relative">
        <h1 class="text-little">Global Admin</h1>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn color="blue darken-1" style="position: absolute; right: 15px; top: 10px;" text v-on="on" @click="info = !info">
              <span class="v-btn__content" style="font-size: 22px;">?</span>
            </v-btn>
          </template>
          <span>Display information about this page</span>
        </v-tooltip>
      </v-row>
      <v-alert :value="info" type="info" color="blue darken-1" transition="slide-y-transition" class="mb-0">
        A zone belongs to a depot that belongs to a region
      </v-alert>
    </v-container>

    <v-divider color="#42a5f5"></v-divider>

    <template>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="blue"
        grow
        slider-color="cyan accent-4"
      >
        <v-tab>
          <v-icon class="mr-4">fas fa-map-marked-alt</v-icon>
          Regions
        </v-tab>
        <v-tab>
          <v-icon class="mr-4">fa fa-store-alt</v-icon>
          Depots
        </v-tab>
        <v-tab>
          <v-icon class="mr-4">map</v-icon>
          Zones
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          :key="0"
        >
          <v-card flat>
            <ManageRegions
            ></ManageRegions>
          </v-card>
        </v-tab-item>

        <v-tab-item
          :key="1"
        >
          <v-card flat>
            <ManageDepots
            ></ManageDepots>
          </v-card>
        </v-tab-item>

        <v-tab-item
          :key="2"
        >
          <v-card flat>

            <ManageZones
            ></ManageZones>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

    </template>
  </section>
</div>
</template>

<script>
    import ManageRegions from "./ManageRegions";
    import ManageDepots from "./ManageDepots";
    import ManageZones from "./ManageZones";

    export default {
        name: "GlobalAdmin",
        components: {
            ManageRegions,
            ManageZones,
            ManageDepots
        },
        data() {
            return {
                tab: 0,
                info: false,

            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/GlobalAdmin/GlobalAdmin.vue